module.exports = __webpack_public_path__ + "img/gift-icon.29cf2bc1.svg";